export const slider = () =>  {
	$('.media__slider-wrapper').slick({
		dots: false,
		speed: 300,
		slidesToShow: 2,
		slidesToScroll: 1,
		swipe: false,
		responsive: [
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 1,
				}
			},
		]
	});

	$('.media__slider-single').on('click', function() {
		const movie = $(this).find('iframe').clone();
		$('.media__slider-modal').addClass('visible');
		$('.media__inner').append(movie);
	});

	$('.media-slider__close').on('click', () => $('.media__slider-modal').removeClass('visible').find('iframe').remove() );
};
